__turbopack_context__.v({
  "className": "cormorant_garamond_870492e5-module__9QO-Ba__className",
});
